import { Col, message, Modal, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { Gantt, WillowDark } from "wx-react-gantt";
import "wx-react-gantt/dist/gantt.css";
import { LoadingOutlined } from "@ant-design/icons";
import noImg from '../../../../assets/static/noImg.jpeg';

import liracrypt from '../../../Liracrypt/liracrypt';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import ApiErrorComp from '../../../ApiErrorComp/ApiErrorComp';
import { useSelector } from 'react-redux';
import { createRoute } from '../../../../utils/CustomFunc';
import ZenModal from '../../../ZenModal';

const ZenGanttChart2 = () => {
    const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState();
    const urlCode = useSelector(state => state.urlCode);
    const [zenModal, setZenModal] = useState();
    const [modal, setModal] = useState({
        // type: props.config.zenModal.typ,
        type: "kanban",
        data: undefined,
        show: false,
        loading: false,
    });
    const toggleModal = ({ show = false, data = undefined, type = '', loading = false }) => {
        setModal({ show, data, type, loading });
    }
    const [config, setConfig] = useState();

    const getData = () => {
        liracrypt.get('/textapi', { dn: 'ZenGanttChart2', ...searchParams })
            .then(({ data }) => {
                setLoading(false);
                if (data.isSuccess) {
                    setConfig(data.config)
                    setData(data.data);
                } else {
                    message.error(data.message || 'Something went wrong');
                }
            }).catch(err => {
                setLoading(false);
                console.log(err);
                ApiErrorComp();
            })
    }

    useEffect(() => {
        setLoading(true);
        getData();
    }, []);


    const zenPopupAction = (zenPopup, value, record) => {
        let urlData = { ...searchParams, ...zenPopup.params };
        if (zenPopup?.props) {
            urlData[zenPopup?.props] = value;
        }
        if (zenPopup?.multiProps) {
            zenPopup?.multiProps.forEach((prop) => {
                urlData[prop] = record[prop];
            });
        }
        if (zenPopup?.typ === 'smodal') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    id: value,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        };
        if (zenPopup?.typ === 'route') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    route: zenPopup?.route,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        }
        if (zenPopup?.api) {
            toggleModal({ show: true, loading: true, type: zenPopup?.typ });
            liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
                toggleModal({
                    show: true,
                    data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
                    loading: false,
                    type: zenPopup?.typ
                })
            });
            return;
        }
        return toggleModal({
            show: true,
            data: { data: zenPopup?.data, record },
            loading: false,
            type: zenPopup?.typ,
        })
    }

    const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
        if (popData.method === 'GET') {
            liracrypt.get(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'POST') {
            liracrypt.post(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    console.log(err);
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'PATCH') {
            liracrypt.patch(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
    }

    const onColumnClick = ({ record, zenPop }) => {
        if (zenPop) {
            let zenPopDataIndex = { ...zenPop };
            setZenModal(zenPopDataIndex);
            if (zenPopDataIndex?.typ === 'newTab') {
                let zenParams = { ...searchParams, ...zenPopDataIndex.params };
                if (zenPopDataIndex?.api) {
                    zenParams.api = zenPopDataIndex?.api;
                }
                let route = createRoute({
                    props: zenPopDataIndex?.props,
                    record,
                    multiProps: zenPopDataIndex?.multiProps,
                    params: { ...zenParams },
                    urlCode,
                    route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
                });
                window.open(route, '_blank')
                return;
            };

            if (zenPopDataIndex?.typ === 'confirmationPopUp') {
                let urlData = { ...searchParams, ...zenPopDataIndex?.onOk?.params };
                if (zenPopDataIndex?.onOk?.multiProps) {
                    zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
                        urlData[prop] = record[prop];
                    });
                };
                if (zenPopDataIndex?.onOk?.props) {
                    urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
                }

                Modal.confirm({
                    title: zenPopDataIndex?.text,
                    okText: zenPopDataIndex?.okButtonText,
                    cancelText: zenPopDataIndex?.cancelButtonText,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            onConfirmation({
                                popData: zenPopDataIndex?.onOk,
                                resolve,
                                reject,
                                urlData
                            });
                        }).catch(() => console.log('Oops errors!'));
                    }
                });
                return;
            }
            zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

        }
    }

    const init = api => {
        api.intercept("select-task", ev => {
            const record = data.tasks.find(x => x.id === ev.id);
            onColumnClick({ record, zenPop: config.zenPop })
            console.log("The id of the selected task:", ev.id);
            return false;
        });
    };




    return (
        <div>
            {
                loading ?
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignContent: 'center',
                        alignItems: 'center',
                        width: '100%'
                    }}>
                        {antIcon}
                    </div> :
                    <div>
                        {
                            data.tasks ?
                                <div>
                                    <ZenModal refreshData={getData} smodalCallback={getData} modal={modal} toggleModal={toggleModal} zenModal={zenModal} />
                                    <WillowDark>
                                        <div className="wxl-content wx-willow-theme move">
                                            <h4>Click the "expand" icon</h4>
                                            <div className="gtcell">
                                                {/* <Fullscreen> */}
                                                <Gantt
                                                    taskTypes={[
                                                        { id: 'task', label: 'Task' },
                                                        { id: 'summary', label: 'Summary' },
                                                        { id: 't0', label: 'T0' },
                                                        { id: 't1', label: 'T1' },
                                                        { id: 't2', label: 'T2' },
                                                        { id: 't3', label: 'T3' },
                                                    ]}
                                                    // columns={data?.columns}
                                                    // init={init}
                                                    tasks={data?.tasks}
                                                    //    links={data?.links}
                                                    // scales={data?.scales}
                                                    readonly={true}
                                                />
                                            {/* </Fullscreen> */}
                                        </div>
                                </div>
                                    </WillowDark>
                                </div> :
    <p>No Data Found</p>
}

                    </div >
            }

        </div >

    )
};

export default ZenGanttChart2;